import { css } from '@emotion/react';
import { Theme } from '../../config/theme';

export default (theme: Theme) => ({
  orderFooter: css`
    position: sticky;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: ${theme.spacing.large};
    background-color: ${theme.color.primary};
    border-top: 1px solid ${theme.color.border};
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: opacity 0.3s ease;
    @media (max-width: 30em) {
      flex-direction: column;
    }
  `,
  hidden: css`
    opacity: 0;
  `,
  show: css`
    opacity: 1;
  `,
  totalContainer: css`
    display: flex;
    min-height: 48px;
    align-items: center;
  `,
  total: css`
    margin-left: ${theme.spacing.large};
  `,
});
